import { useFormContext } from 'react-hook-form';
import { SettlementRuleTrigger } from '@mews-commander/data-access';
import { SelectField, DurationInputField } from '@mews-commander/form';
import { createOption } from '@mews-commander/ui';
import { CompoundField, Grid, Stack } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { Option } from '@mews-commander/types';
import { SettlementRuleFormField, SettlementRuleOffsetType } from '../types';
import { FormValues } from './schema';

const offsetTypeOptions: Option[] = [
    createOption({
        value: SettlementRuleOffsetType.Before,
        label: lt('SettlementRuleOffsetTypeBefore'),
    }),
    createOption({
        value: SettlementRuleOffsetType.After,
        label: lt('SettlementRuleOffsetTypeAfter'),
    }),
];

const triggerFieldOptions: Option[] = [
    createOption({
        label: lt('PaymentPolicyTriggerConfirmation'),
        value: SettlementRuleTrigger.Confirmation,
    }),
    createOption({
        label: lt('PaymentPolicyTriggerArrivalDate'),
        value: SettlementRuleTrigger.StartDate,
    }),
    createOption({
        label: lt('PaymentPolicyTriggerCheckInTime'),
        value: SettlementRuleTrigger.Start,
    }),
    createOption({
        label: lt('PaymentPolicyTriggerDepartureDate'),
        value: SettlementRuleTrigger.EndDate,
    }),
    createOption({
        label: lt('PaymentPolicyTriggerCheckOutTime'),
        value: SettlementRuleTrigger.End,
    }),
];

export const PaymentPolicyTimingFields = () => {
    const { watch, setValue } = useFormContext<FormValues>();

    const trigger = watch(SettlementRuleFormField.Trigger);

    return (
        <CompoundField label={lt('PaymentPolicyTiming')} name="timing" required>
            <Stack spacing="100" vertical>
                <SelectField
                    name={SettlementRuleFormField.Trigger}
                    options={triggerFieldOptions}
                    showEmptyValue={false}
                    onChange={(_, value) => {
                        if (value === SettlementRuleTrigger.Confirmation) {
                            setValue(SettlementRuleFormField.OffsetType, SettlementRuleOffsetType.After);
                        }
                    }}
                />
                <Grid templateColumns="3fr 1fr" gap="100">
                    <DurationInputField
                        name={SettlementRuleFormField.Offset}
                        units={{ days: true, hours: true, minutes: true }}
                        required
                    />
                    <SelectField
                        name={SettlementRuleFormField.OffsetType}
                        options={offsetTypeOptions}
                        showEmptyValue={false}
                        disabled={trigger === SettlementRuleTrigger.Confirmation}
                    />
                </Grid>
            </Stack>
        </CompoundField>
    );
};
